import gql from 'graphql-tag';

export const statisticsQuery = gql`
  query statistics($startTime: String, $endTime: String) {
    statistics(startTime: $startTime, endTime: $endTime) {
      averageEventsCategory
      averageEventsPerDay
      averageNewsCategory
      averagePollsCategory
      averageUsersPerCourse
      averageVotes
      courses
      coursesCreatedManually
      futureEvents
      profilePicApprovals
      publishedEvents
      publishedNews
      publishedPolls
      users
      withNonDefaultProfilePicture
      # Video statistics
      totalVideos
      sessionVideos
      shortSessionVideos
      mediumSessionVideos
      longSessionVideos
      poseVideos
      modificationVideos
      totalVideoViews
      completedVideoViews
      
      # Detailed Video View Statistics by Type
      sessionVideoViews
      sessionVideoCompletions
      sessionVideoCompletionRate
      poseVideoViews
      poseVideoCompletions
      poseVideoCompletionRate
      modificationVideoViews
      modificationVideoCompletions
      modificationVideoCompletionRate
      
      # Detailed Video View Statistics by Duration
      shortSessionViews
      shortSessionCompletions
      shortSessionCompletionRate
      mediumSessionViews
      mediumSessionCompletions
      mediumSessionCompletionRate
      longSessionViews
      longSessionCompletions
      longSessionCompletionRate
      
      # Manual statistics
      totalManuals
      totalManualViews
      # Homepage
      totalPosts
      totalComments
      totalPostCreations
    }
  }
`;
